/**
 * 公告栏组件 - 中式典雅风格
 * 显示在页面顶部，不可关闭
 */
import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

// 中式配色
const COLORS = {
  paper: '#F8F6F1',
  teaBrown: '#7D6B55',
  bambooGreen: '#6B8E7C',
  cinnabar: '#C44536',
  ink: '#2C2C2C',
};

export default function AnnouncementBar({ announcement }) {
  // 无公告内容或未启用时不显示
  if (!announcement) {
    return null;
  }

  return (
    <div
      style={{
        background: COLORS.teaBrown,
        padding: '12px 16px',
        textAlign: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 101,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text
        style={{
          color: COLORS.paper,
          fontSize: 14,
          letterSpacing: '0.1em',
        }}
      >
        {announcement}
      </Text>
    </div>
  );
}
